import { LoadingOverlay } from '@mantine/core';

export default function LoaderOverlay({ visible = true }: { visible?: boolean }) {
  return (
    <LoadingOverlay
      mih={'100%'}
      visible={visible}
      zIndex={1000}
      loaderProps={{ color: 'var(--mantine-color-washday-primary-9)', type: 'bars' }}
      overlayProps={{ radius: 'sm', blur: 2 }}
    />
  );
}
